import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.188 11.651a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m-2.667-4a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m2.667 1.334a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m-2.667 4a.666.666 0 1 0 0 1.332.666.666 0 0 0 0-1.332m0-2.667a.666.666 0 1 0 0 1.332.666.666 0 0 0 0-1.332m5.333 0a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m-2.666-4a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m2.666 1.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m1.614-3.186a4.667 4.667 0 0 0-8.907 1.26 2.67 2.67 0 0 0-2.04 2.593 2.67 2.67 0 0 0 .893 2 .667.667 0 1 0 .88-1 1.33 1.33 0 0 1-.44-1 1.333 1.333 0 0 1 1.334-1.333.667.667 0 0 0 .666-.667 3.333 3.333 0 0 1 6.487-1.073.67.67 0 0 0 .52.446 2 2 0 0 1 1.66 1.96c.01.491-.166.967-.493 1.334a.666.666 0 0 0 .986.893 3.334 3.334 0 0 0-1.546-5.387zm-1.614 8.52a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })